import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getCalendarYears,
  getCalendars,
  statusCalendar,
  deleteCalendar,
} from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Button from '../../../ui/Button';
import Modal from '../../../ui/Modal';
import Icon from '@mdi/react';
import { mdiCalendarOutline } from '@mdi/js';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';

const mapState = (state, ownProps) => {
  let auth = state.auth;
  let scope = auth?.isAuth ? auth.authorities : {};
  let loading = state.async.loading;

  let calendars = state.calendars;
  let years = calendars?.years?.[0] ? calendars.years : [];
  return {
    auth,
    scope,
    loading,
    calendars,
    years,
  };
};

const actions = {
  getCalendars,
  getCalendarYears,
  statusCalendar,
  deleteCalendar,
  closeModal,
};

function ModalSetActive({
  auth,
  scope,
  history,
  calendars,
  years,
  statusCalendar,
  getCalendars,
  getCalendarYears,
  deleteCalendar,
  closeModal,
}) {
  const [state, setState] = useState({
    title: 'Kalender',
    itemPerPage: 10,
    currentPage: 1,
    searchText: '',
    isActive: false,
    calendars: {},
  });
  const screenWidth = useScreenWidth();

  useEffect(() => {
    getCalendars(auth, history);
    getCalendarYears(auth, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setState({
      ...state,
      calendars: calendars,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calendars]);

  // Set Active Calendar
  const handleStatusCalendar = (e, value) => {
    e.preventDefault();
    let activeCal =
      calendars?.items?.[0] && calendars.items.find((cal) => cal.status);

    let newValue = {
      ...value,
      status: !value.status,
    };
    statusCalendar(auth, history, newValue);
    if (activeCal?.id === value?.id && activeCal?.status) {
      setTimeout(() => {
        window.location.reload();
        closeModal();
      }, 1000);
    }
  };

  const handleEditCalendar = (calendar) => {
    history.push({
      pathname: '/calendar/edit/' + calendar.id,
      state: { detail: calendar },
    });
    closeModal();
  };

  const handleDeleteCalendar = (calendar) => {
    deleteCalendar(auth, history, calendar.id);
  };

  const List = ({
    scope,
    items,
    title,
    currentPage,
    itemPerPage,
    onStatus,
    onEdit,
    onDelete,
  }) => {
    return (
      <>
        {items?.[0] &&
          items.map((item, index) => (
            <ListItems
              key={item.id}
              index={index}
              item={item}
              currentPage={currentPage}
              itemPerPage={itemPerPage}
              scope={scope}
              onStatus={onStatus}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        {!items?.[0] && (
          <tr key={0}>
            <td colSpan='7'>
              Tidak ada <span className='is-lowercase'>{title}</span>
            </td>
          </tr>
        )}
      </>
    );
  };

  const ListItems = ({
    item,
    currentPage,
    itemPerPage,
    index,
    scope,
    onStatus,
    onEdit,
    onDelete,
  }) => {
    const page = (currentPage - 1) * itemPerPage;
    return (
      <tr>
        <td className='has-text-centered'>{page + index + 1}</td>
        <td>{item?.title}</td>
        <td className='has-text-centered'>{item?.year}</td>
        <td style={{ width: 100 }}>
          <div className='content-wrap flex justify-center'>
            <div>
              {scope.m['calendar_edit'] && (
                <div className='control'>
                  {scope?.m?.['calendar_active'] && (
                    <div
                      className='tags has-addons hand-pointer'
                      onClick={(e) => onStatus(e, item)}
                    >
                      <span className='tag is-rounded is-dark'>
                        {item?.status ? '' : 'No'}
                      </span>
                      <span className='tag is-rounded is-info'>
                        {item?.status ? 'Aktif' : ''}
                      </span>
                    </div>
                  )}
                  {!scope?.m?.['calendar_active'] && (
                    <div className='tags has-addons'>
                      <span className='tag is-dark'>
                        {item?.status ? '' : 'No'}
                      </span>
                      <span className='tag is-info'>
                        {item?.status ? 'Aktif' : ''}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </td>
        <td className='has-text-centered'>
          <div className='buttons middle flex justify-center'>
            {scope?.m?.['calendar_edit'] && (
              <Button variant='edit' onClick={() => onEdit(item)} />
            )}
            {scope?.m?.['calendar_delete'] && (
              <Button
                variant='delete'
                disabled={item.status ? true : false}
                onClick={() => onDelete(item)}
              />
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <Modal
      variant='info'
      label='noLabel'
      noBorder={true}
      closeModal={closeModal}
      width={screenWidth > 700 ? 700 : screenWidth}
    >
      <div className='flex justify-between align-center is-size-5 py-4 px-4'>
        <span className='flex align-center has-text-info has-text-weight-semibold'>
          <span className='icon is-medium'>
            <Icon path={mdiCalendarOutline} size={1} />
          </span>
          <span>Set Kalender Aktif</span>
        </span>
      </div>
      <div style={{ borderBottom: '1px solid #e5e7eb' }}></div>
      <div className='table-container c-table mx-4 mt-4 mb-2'>
        <table
          id='fadein'
          className='table is-fullwidth is-bordered is-hoverable is-narrow'
        >
          <thead>
            <tr>
              <th className='has-text-centered'>No</th>
              <th>Judul Kalender</th>
              <th className='has-text-centered'>Tahun Ajaran</th>
              <th className='has-text-centered'>Status</th>
              <th className='has-text-centered'>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <List
              auth={auth}
              scope={scope}
              items={state.calendars?.items}
              years={years}
              title={state.title}
              currentPage={state.currentPage}
              itemPerPage={state.itemPerPage}
              onStatus={handleStatusCalendar}
              onEdit={handleEditCalendar}
              onDelete={handleDeleteCalendar}
            />
            <tr>
              <td colSpan={3}>
                <div className='control my-2'>
                  <div className='tags has-addons'>
                    <span className='tag is-rounded is-info'>
                      Total
                    </span>
                    <span className='tag is-rounded is-info is-light'>
                      {calendars?.items?.length}
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  );
}

export default withRouter(connect(mapState, actions)(ModalSetActive));
